export const LEVELS = [["middle", "Middle school"], ["jv", "JV"], ["varsity", "Varsity"], ["aau", "AAU / club"]];
export const POSITIONS = [["all", "All positions"], ["guard", "Guards"], ["wing", "Wings"], ["big", "Bigs"]];
const GROUP = { PG: "guard", SG: "guard", G: "guard", SF: "wing", W: "wing", F: "wing", PF: "big", C: "big" };

export const benchmarkLabel = (b) =>
  `${LEVELS.find(([k]) => k === b.level)?.[1] ?? b.level} · ${POSITIONS.find(([k]) => k === (b.position ?? "all"))?.[1]}`;

const firstPosition = (p) => (Array.isArray(p?.positions) && p.positions.length ? p.positions[0] : p?.position);

/** Best admin table for this player: same level + position group, then same level for all positions. */
export const autoBenchmark = (list, p) => {
  if (!p || !Array.isArray(list)) return null;
  const level = p.level === "jv" ? "jv" : "varsity";
  const group = GROUP[String(firstPosition(p) ?? "").toUpperCase()] ?? null;
  return list.find((b) => b.level === level && group && b.position === group) ?? list.find((b) => b.level === level && !b.position) ?? null;
};


export const PCTS = [["p25", "25th"], ["p50", "50th"], ["p75", "75th"], ["p90", "90th"]];
/** Lower is better for timed drills and body fat (their 90th-percentile cutoff is the smallest number). */
export const LOWER_BETTER = new Set(["lane_agility_s", "three_quarter_sprint_s", "reactive_shuttle_s", "body_fat_pct"]);
const TIERS = [["p90", 90, "Top 10%"], ["p75", 75, "Top 25%"], ["p50", 50, "Top 50%"], ["p25", 25, "Top 75%"]];

/** Where a value ranks against a table's cutoffs for one metric, or null when there are no cutoffs. */
export const rankOf = (key, value, cuts) => {
  const present = TIERS.filter(([k]) => cuts?.[k] != null);
  if (value == null || !present.length) return null;
  const ok = (cut) => (LOWER_BETTER.has(key) ? value <= cut : value >= cut);
  const hit = present.find(([k]) => ok(cuts[k]));
  if (hit) return { score: hit[1], label: hit[2] };
  const low = present[present.length - 1];
  return low[0] === "p25" ? { score: 0, label: "Bottom 25%" } : { score: 0, label: `Below ${low[1]}th percentile` };
};

export const benchmarkPhrase = (b) => {
  const level = LEVELS.find(([k]) => k === b.level)?.[1] ?? b.level;
  return b.position ? `${level} ${POSITIONS.find(([k]) => k === b.position)?.[1].toLowerCase()}` : `${level} players`;
};

/** The player's strongest top-50%-or-better metric against a table, e.g. { key, label: "Top 25%" }. */
export const bestRank = (b, bests) => {
  if (!b?.percentiles || !bests) return null;
  let best = null;
  Object.entries(b.percentiles).forEach(([key, cuts]) => {
    const r = rankOf(key, bests[key], cuts);
    if (r && r.score >= 50 && (!best || r.score > best.score)) best = { key, ...r };
  });
  return best;
};
